'use strict';

angular.module('mx.SolutionBuilderAgent').controller('mx.SolutionBuilderAgent.HelpArticlePageController', MxViewHelpController);

MxViewHelpController.$inject = [
	'$stateParams',
	'mx.internationalization',
	'mx.SolutionBuilderAgent.ViewHelpService',
	'mx.shell.Config',
	'mx.shell.ToolbarManager',
	'mx.shell.LeftSidebarService',
];

function MxViewHelpController($stateParams, i18n, viewHelpService, mxConfig, mxToolbarManager, leftSidebarService) {
	const vm = this;
	vm.i18n = i18n.get('shell.common');
	vm.error = i18n.get('solutionBuilderAgent.layouts.help-article-page.page-cant-be-loaded');
	vm.isWorkspaceManagement = mxConfig.settings.productName === 'Workspace Management';
	vm.loaded = false;

	vm.$onInit = function () {
		if (!vm.popup) {
			//standalone mode
			mxToolbarManager.setToolbarVisibility(false);
			leftSidebarService.isVisible = false;
			vm.helpSourceType = 2;
			vm.helpValue = '{"ObjID":"' + $stateParams.objectId + '"}';
		}

		if (vm.helpData) {
			vm.loaded = true;
		} else {
			viewHelpService.getHelpData(vm.helpSourceType, vm.helpValue).then(
				function (helpData) {
					if (helpData && helpData.data) {
						vm.helpData = helpData.data;
						vm.articleId = helpData.articleId;

						if (helpData.hash) {
							window.setTimeout(function () {
								window.location.hash = helpData.hash;
							}, 500);
						}
					}
					vm.loaded = true;
				},
				function () {
					vm.loaded = true;
				}
			);
		}
	};

	vm.cancelViewHelp = function (calledFromSidePanel) {
		viewHelpService.cancelViewHelp(calledFromSidePanel);
	};

	vm.showMore = function () {
		viewHelpService.showMore(vm.helpSourceType, vm.helpValue);
	};
}
